<template>
  <div class="chat_avatar">
    <v-avatar :size="size" color="white" class="primary--text fw500 chat_avatar__main">
      <v-icon v-if="isDelete">mdi-delete</v-icon>
      <v-img
        v-else-if="src"
        :src="src.includes('http') ? src : apiDomain + '/min/' + src"
        :height="size"
        :width="size"
        alt=""
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <div v-else class="d-flex align-center">
        {{ textShow }}
      </div>
    </v-avatar>
    <div v-if="online" class="chat_avatar__online rounded-circle green darken-1" />
  </div>
</template>

<script>
export default {
  name: 'ChatAvatar',
  props: {
    size: { type: Number, default: 50 },
    src: String,
    text: String,
    online: Boolean,
    isDelete: Boolean,
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    textShow() {
      if (this.text) {
        const [firstWord, secondWord] = this.text.split(' ')
        return firstWord.charAt(0) + (secondWord ? secondWord.charAt(0) : '')
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_avatar {
  position: relative;
  &__main {
    box-shadow: 0px 4px 4px rgba(133, 133, 133, 0.25);
  }
  &__online {
    width: 10px;
    height: 10px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
